import { type ApolloError } from '@apollo/client'

export enum QueryErrorTypes {
  TIMEOUT = 'timeout',
  UNKNOWN = 'unknown',
  NONE = 'none',
}

// https://github.com/instacart/carrot/blob/master/enterprise/frigate/app/infrastructure/frigate/errors.rb
const FrigateErrorCodes = {
  Unavailable: 10028,
  Timeout: 10001,
} as const

export const getQueryErrorType = (error?: string): QueryErrorTypes => {
  if (!error) {
    return QueryErrorTypes.NONE
  }

  if (
    error.toLowerCase().includes('timeout') ||
    error.toLowerCase().includes('ran for longer than')
  ) {
    return QueryErrorTypes.TIMEOUT
  } else {
    return QueryErrorTypes.UNKNOWN
  }
}

export const getFrigateQueryErrorType = (error?: ApolloError): QueryErrorTypes => {
  if (!error) {
    return QueryErrorTypes.NONE
  }

  const frigateErrorCode = error.graphQLErrors?.[0]?.extensions?.code

  if (
    frigateErrorCode === FrigateErrorCodes.Timeout ||
    frigateErrorCode === FrigateErrorCodes.Unavailable
  ) {
    return QueryErrorTypes.TIMEOUT
  }

  return getQueryErrorType(error.message)
}
